/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Label, SelectSimple, TextArea } from 'ypf-pas-general-ui-components';

import { getRejectionClassification } from '../../services/serviceRequest';
import './RejectionForm.scss';

const showRejectionMessage = (sdsNumber) => (
  <>
    <p className="text-center mb-0">
      ¿Querés rechazar la solicitud de servicio <strong>{sdsNumber}</strong>?
    </p>
    <p className="text-center mt-0 mb-4">
      Por favor seleccioná una clasificación y escribí un motivo de rechazo.
    </p>
  </>
);
const showCancelMessage = (sdsNumber) => (
  <>
    <p className="text-center mb-0">
      ¿Querés cancelar la aceptación de la solicitud de servicio <strong>{sdsNumber}</strong>?
    </p>
    <p className="text-center mt-0 mb-4">Por favor escribí un motivo de cancelación.</p>
  </>
);

const RejectionForm = ({
  sdsNumber,
  classification,
  reason,
  withClassification,
  setFieldValue,
  setFieldTouched
}) => {
  const [rejectionClassification, setRejectionClassification] = useState([]);

  useEffect(() => {
    if (withClassification) {
      getRejectionClassification().then((res) => setRejectionClassification(res));
    } else {
      setFieldTouched('classification');
    }
  }, [withClassification]);

  return (
    <>
      {withClassification ? showRejectionMessage(sdsNumber) : showCancelMessage(sdsNumber)}
      <div className="rejection-form d-flex flex-column gap-3">
        {withClassification && (
          <div>
            <Label size="xl" value="Clasificación" />
            <SelectSimple
              name="classification"
              onChange={(optionSelected) =>
                setFieldValue('classification', optionSelected.value) &&
                setFieldTouched('classification')
              }
              options={rejectionClassification}
              placeholder="Seleccioná una clasificación"
              value={classification}
            />
          </div>
        )}
        <TextArea
          label="Comentario"
          maxLength={512}
          name="reason"
          onChange={(e) => setFieldValue('reason', e.target.value)}
          resize={false}
          value={reason}
        />
        <hr className="my-0" />
      </div>
    </>
  );
};

RejectionForm.propTypes = {
  sdsNumber: PropTypes.string.isRequired,
  classification: PropTypes.number,
  reason: PropTypes.string,
  withClassification: PropTypes.bool,
  setFieldValue: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired
};

RejectionForm.defaultProps = {
  classification: 0,
  reason: '',
  withClassification: false
};

export default RejectionForm;
